<template>
  <section class="dragonsone-book-container">
    <div class="dragonsone-synopsis">
      <div class="arrow-container">
        <div>
          <a @click="open('home')"><i class="fa-solid fa-angle-left"></i> </a>
        </div>
        <div class="custom-text">
          <a @click="open('home')">Back to Home</a>
        </div>
      </div>
      <h2>Eclipse Dragons - Book 1</h2>
      <div class="info-container">
        <div class="left-aligned-image-container">
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Eclipse-1.jpg" alt="Eclipse Dragons Image">
        </div>
        <div class="text-container">
          <p>"Shadows and Light: The Tale of the Eclipse Dragons" follows Lysandra, a resilient young woman whose
            discovery of a dragon egg after a solar eclipse propels her into an ancient prophecy of celestial
            importance. As she nurtures Solanis, the dragon of the sun, and Luneth, the dragon of the moon, she finds
            herself at the heart of a fantastical power struggle. </p><br>
          <p>The story unfolds through Lysandra's perspective, showcasing her growth from a solitary figure reliant on
            crutches to a unifying force capable of leading a motley crew against a formidable foe. Her allies are a
            microcosm of her world's diversity: Finn with his soothing lute, Zephyra with her unpredictable spells,
            Baird with his steadfast skepticism turned faithful artisanship, Nia whose silent love and healing touch
            mend more than physical wounds, and Corvin, whose complaints mask a fierce loyalty.</p>
          <br>
          <p>Together, they face Obsidior, the dragon born from Solanis and Luneth's union. Unlike his parents, Obsidior
            views his kind as supreme, seeking to eradicate humans and fairies to establish draconian dominance. As he
            rallies a legion, Lysandra and her friends must counter with unity, forming an alliance of guilds inclusive
            of warriors, mages, and paladins—a testament to the story's overarching theme of coalition-building.</p>
          
        </div>
      </div>
      <div class="cta-row">
            <div class="read-btn"><a href="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/pdfs/Eclipse_Dragon_Book_1.pdf"><button class="read-sample-btn">READ
                  SAMPLE</button></a></div>
            <div class="read-btn">
              <a href="https://www.amazon.com/gp/product/B0CP1K3VGG?ref_=dbs_m_mng_rwt_calw_tkin_0&storeType=ebooks"><button
                  class="cta-2">BUY BOOK</button></a>
            </div>
          </div>
    </div>
  </section>
  <section class="dragonstwo-book-container">
    <div class="dragonstwo-synopsis">
      <h2>Eclipse Dragons The Rogue Mages Uprising - Book 2</h2>
      <div class="info-container">
        <div class="left-aligned-image-container">
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Eclipse-2.jpg" alt="Eclipse Dragons The Rogue Mages UprisingBook 2 Image">
        </div>
        <div class="text-container">
          <p>Step into a world where magic and dragons collide in "Eclipse Dragons: The Rogue Mages Uprising". Chapter 1
            sets the stage for an epic tale of valor, betrayal, and the unwavering strength of unity. Lysandra, a
            formidable mage, stands atop the highest tower, gazing upon a city where magic and humanity coexist in
            harmony. But peace shatters as Half-Dragons, led by a monstrous figure with red eyes and scales of blackened
            steel, besiege the city. Lysandra's heart pounds with fear and determination as she commands the city's
            defenses and mages in a fierce battle. </p><br>
          <p>Just when all seems lost, Lysandra is captured, plunging the city into despair. However, hope flickers in
            the darkness as Solanis and Luneth, majestic dragons, join the fray, turning the tides of battle. In a twist
            of fate, a fraction of Half-Dragons defects, aligning with the defenders for a common cause. But unbeknownst
            to them, Voxeran the Deceiver plots in the shadows, seeking to exploit the chaos for his own gain. As the
            city burns and defenders rally under the guidance of Lysandra, Boltzdameek, and ThunderCloud, the true test
            of their courage and unity begins.</p>
          <br>
          <p>Eclipse Dragons unravels a narrative of mystical creatures, fierce battles, and the timeless pursuit of
            peace. Will Lysandra and her allies withstand the darkness that encroaches their realm, or will the prophecy
            of the Eclipse of Worlds spell doom for all? Dive into "Eclipse Dragons: The Rogue Mages Uprise" and embark
            on a journey where the line between friend and foe blurs, and the heart of a warrior is the only light in
            the encroaching darkness.</p>
         
        </div>
      </div>
      <div class="cta-row">
            <div class="read-btn"><a href="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/pdfs/Eclipse_Dragons_The_Rogue_Mages+_Uprising_Book_2.pdf"><button
                  class="read-sample-btn white-btn">READ SAMPLE</button></a></div>
            <div class="read-btn">
              <a href="https://www.amazon.com/Eclipse-Dragons-Rogue-Mages-Uprising/dp/B0CZQ1HTT4/"><button
                  class="cta-2 white-btn">BUY BOOK</button></a>
            </div>
          </div>
    </div>
  </section>
  <section class="dragonsthree-book-container">
    <div class="dragonsthree-synopsis">
      <h2>Eclipse Dragons The Warlord's Awakening - Book 3</h2>
      <div class="info-container">
        <div class="left-aligned-image-container">
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Eclipse-3.jpg" alt="Eclipse Dragons The Warlord's Awakening Image">
        </div>
        <div class="text-container">
          <p>In the ancient realm of Eldoria, where magic and steel intermingle, a fierce and looming threat
            emerges—Voxeran, the Dark Conqueror, whose ambition is to reshape the very fabric of reality. The realm
            teeters on the edge of destruction, and only a band of unlikely heroes stands in the way of its
            annihilation. </p><br>
          <p>At the heart of this tale is Lysandra Nightshade, a warrior burdened with a dual legacy. Known as the Dark
            Phoenix, she embodies both the fierce might of a warlord and the compassionate soul of a healer. Haunted by
            her own physical limitations and a past shrouded in mystery, Lysandra must navigate her inner turmoil to
            harness the full extent of her power. With her amethyst eyes reflecting a spirit of indomitable will, she
            leads a small but formidable group of allies against Voxeran's encroaching darkness.</p>
          <br>
          <p>Flanking Lysandra are her trusted companions: Seraphina, the fiery archer whose precision and resolve never
            waver; Adrien, the stormy-eyed swordsman whose strength and loyalty are unmatched; Solanis, whose control
            over fire burns with a passion for justice; and Luneth, the ice-wielder whose cool demeanor masks a fierce
            protective instinct. Together, they form a tight-knit circle, bound by purpose and unyielding in their
            mission to protect their realm.</p>
         
        </div>
      </div>
      <div class="cta-row">
            <div class="read-btn"><a
                href="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/pdfs/Eclipse_Dragons_The_Warlord's_Awakening_Battles_of_the_Multiverse_3.pdf"><button
                  class="read-sample-btn white-btn">READ SAMPLE</button></a></div>
            <div class="read-btn">
              <a href="https://www.amazon.com/gp/product/B0D91LXSWL?ref_=dbs_m_mng_rwt_calw_tpbk_2&storeType=ebooks"><button
                  class="cta-2 white-btn">BUY BOOK</button></a>
            </div>
          </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'EclipseView',
  data() {
    return {
      currentLocation: null
    }
  },
  async mounted() {
    this.currentLocation = this.$route.name
    window.scrollTo(0, 0)
  },
  methods: {
    open(target) {
      this.currentLocation = target
      this.$router.push({ name: target })
    }
  }
}
</script>

<style>
.dragonsone-synopsis
.arrow-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: none;
  padding-top: 64px;
  font-weight: bold;
  cursor: pointer;
  gap: 8px;
  a {
    color: var(--secondary);
  }
}
</style>
